/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getTicketsRequest: ['page', 'page_size', 'sort', 'nextPage', 'search'],
  getTicketsSuccess: ['list'],

  getTicketsFetchingReset: null,
  getTicketsReset: null,

  getTicketIdRequest: ['id'],
  getTicketIdSuccess: ['focusRow'],
  getTicketIdReset: null,

  deleteTicketRequest: ['id'],
  deleteTicketSuccess: ['deleteTicketResult'],
  deleteTicketReset: null,

  //fake
  suggestHelpAdminData: ['data'],
  suggestHelpAdminSort: ['sort'],

  suggestListRequest: ['id'],
  suggestListSuccess: ['focusRow'],
  suggestListReset: null,
})

export const SuggestHelpAdminReduxTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  page: 1,
  page_size: 15,

  deleteTicketResult: null,
  deleteTicketFetching: false,

  idFetching: false,

  focusRow: null,
})

/* ------------- Selectors ------------- */

export const ticketsSelectors = {
  tickets: state => state.suggestHelpAdmin,
}

/* ------------- Reducers ------------- */

export const getTicketsRequest = (state, {page, page_size, sort, nextPage, search}) => {
  const newState = {
    fetching: true,
  }
  page && (newState.page = page)
  page_size && (newState.page_size = page_size)
  return state.merge(newState)
}
export const getTicketsSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}
export const getTicketsFetchingReset = state => {
  return state.merge({fetching: false, idFetching: false, deleteTicketFetching: false})
}

export const getTicketsReset = state => {
  return state.merge({
    list: null,
    fetching: false,

    page: 1,
    page_size: 15,

    deleteTicketResult: null,
    deleteTicketFetching: false,

    idFetching: false,

    focusRow: null,
  })
}

export const getTicketIdRequest = (state, {id}) => {
  return state.merge({idFetching: true})
}
export const getTicketIdSuccess = (state, {focusRow}) => {
  return state.merge({idFetching: false, focusRow})
}
export const getTicketIdReset = state => {
  return state.merge({focusRow: null})
}

export const deleteTicketRequest = (state, {id, data}) => {
  return state.merge({deleteTicketFetching: true})
}
export const deleteTicketSuccess = (state, {deleteTicketResult}) => {
  return state.merge({
    list: {
      ...state.list,
      results: [...state.list.results.filter(ticket => ticket.id !== deleteTicketResult)],
    },
    deleteTicketFetching: false,
  })
}
export const deleteTicketReset = (state, {}) => {
  return state.merge({deleteTicketFetching: false, deleteTicketResult: null})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_TICKETS_REQUEST]: getTicketsRequest,
  [Types.GET_TICKETS_SUCCESS]: getTicketsSuccess,

  [Types.GET_TICKETS_FETCHING_RESET]: getTicketsFetchingReset,
  [Types.GET_TICKETS_RESET]: getTicketsReset,

  [Types.GET_TICKET_ID_REQUEST]: getTicketIdRequest,
  [Types.GET_TICKET_ID_SUCCESS]: getTicketIdSuccess,
  [Types.GET_TICKET_ID_RESET]: getTicketIdReset,

  [Types.DELETE_TICKET_REQUEST]: deleteTicketRequest,
  [Types.DELETE_TICKET_SUCCESS]: deleteTicketSuccess,
  [Types.DELETE_TICKET_RESET]: deleteTicketReset,
})
